import * as React from 'react';
import Box from '@mui/joy/Box';
import IconButton from '@mui/joy/IconButton';
import List from '@mui/joy/List';
import ListItem from '@mui/joy/ListItem';
import ListItemButton from '@mui/joy/ListItemButton';
import ListItemContent from '@mui/joy/ListItemContent';
import Typography from '@mui/joy/Typography';
import Dropdown from '@mui/joy/Dropdown';
import Menu from '@mui/joy/Menu';
import MenuButton from '@mui/joy/MenuButton';
import MenuItem from '@mui/joy/MenuItem';
import ListItemDecorator from '@mui/joy/ListItemDecorator';
import Avatar from '@mui/joy/Avatar';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faGear,
  faUser,
  faRightFromBracket,
  faTag,
  faPeopleRoof,
  faChartSimple,
  faTruck,
  faUsersLine,
  faGasPump,
  faFileInvoiceDollar,
  faBars,
  faChevronDown,
  faChevronUp,
  faRoad,
  faTruckRampBox,
  faQuestionCircle,
  faCogs,
  faChevronLeft,
  faChevronRight,
  faRepeat,
  faChartLine,
  faBoxesStacked,
  faWarehouse,
  faFileText,
  faFolderOpen,
  faBell,
  faChartBar,
} from '@fortawesome/free-solid-svg-icons';
import sidebarLogo from '../Images/ebnlogolg.png';
import smallLogo from '../Images/ebnlogosm.png';
import { useMediaQuery } from '@mui/material';
import axios from 'axios';
import { API } from '../API/api';
import { useAuth } from '../Context/AuthContext';
import { useNavigate, useLocation } from 'react-router-dom';
import { styled } from '@mui/joy/styles';
import { CssVarsProvider } from '@mui/joy/styles';
import Switch from '@mui/joy/Switch';
import { useEffect } from 'react';

const NavbarContainer = styled('div')(({ theme }) => ({
  position: 'fixed',
  top: '20px',
  left: '20px',
  right: '20px',
  height: '80px',
  backgroundColor: 'rgba(197, 215, 253, 0.47)',
  borderRadius: '30px',
  boxShadow: '0 4px 20px rgba(0, 0, 0, 0.05)',
  display: 'flex',
  alignItems: 'center',
  padding: '0 24px',
  zIndex: 1200,
  [theme.breakpoints.down('sm')]: {
    top: '0',
    left: '0',
    right: '0',
    borderRadius: '0',
    height: '60px',
    padding: '0 16px',
  },
}));

const UserProfileButton = styled(MenuButton)({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  padding: '8px 16px',
  borderRadius: '20px',
  transition: 'all 0.2s ease',
  '&:hover': { backgroundColor: 'rgba(0, 0, 0, 0.04)' },
});

// UPDATED: hides on mobile when sidebar is open or when navbar layout is active
const MobileMenuButton = ({ isNavbar, sidebarOpen, toggleSidebar }) => {
  if (isNavbar || sidebarOpen) return null;
  return (
    <IconButton
      onClick={toggleSidebar}
      variant="plain"
      color="neutral"
      sx={{
        display: { xs: 'flex', md: 'none' },
        position: 'fixed',
        top: '10px',
        left: '10px',
        zIndex: 1400,
        bgcolor: 'white',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        '&:hover': { bgcolor: '#f5f5f5' },
      }}
    >
      <FontAwesomeIcon icon={faBars} />
    </IconButton>
  );
};

export default function HeaderSidebar({ knowIsNavbar, knowSidebarOpen }) {
  const [sidebarOpen, setSidebarOpen] = React.useState(false);
  const [isNavbar, setIsNavbar] = React.useState(() => {
    const saved = localStorage.getItem('layoutPreference');
    return saved ? JSON.parse(saved) : false;
  });
  const [activeDropdown, setActiveDropdown] = React.useState(null);
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down('md'));
  const [accountMenuOpen, setAccountMenuOpen] = React.useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { logout } = useAuth();
  const [mobileMenuOpen, setMobileMenuOpen] = React.useState(false);

  const toggleSidebar = () => setSidebarOpen((prev) => !prev);
  const toggleAccountMenu = () => setAccountMenuOpen((prev) => !prev);
  const authState = useAuth().authState;

  const handleLogout = () => {
    const tkn = authState;
    axios
      .post(
        `${API}/logout`,
        {},
        {
          headers: { Authorization: `Bearer ${tkn.token}` },
        }
      )
      .then(() => {
        logout();
      })
      .catch((error) => {
        console.error('Logout error:', error);
      });
  };

  const [infoUser, setInfoUser] = React.useState({
    name: '',
    numberRole: '',
    roles: [],
    Permissions: [],
  });

  const SidebarInfo = [
    {
      name: 'Tableau de bord',
      icon: faChartSimple,
      route: '/Dashboard',
      role: ['admin', 'user-facture', 'user', 'super-admin'],
      permission: 'dashboard',
    },
    {
      name: 'Aide à la décision',
      icon: faChartLine,
      route: '/decision-support',
      role: ['admin', 'user-facture', 'user', 'super-admin'],
      permission: 'dashboard',
    },

    {
      name: 'Transport',
      icon: faTruck,
      route: 'null',
      role: ['admin', 'user-facture', 'user', 'super-admin'],
      child: [
        {
          name: 'Voyages',
          icon: faRoad,
          route: '/Transport/Voyages',
          role: ['admin', 'user-facture', 'user', 'super-admin'],
          permission: 'voyages',
        },
        {
          name: 'Tarification',
          icon: faTag,
          route: '/Transport/Tarification',
          role: ['admin', 'user-facture', 'user', 'super-admin'],
          permission: 'tarifications',
        },
        {
          name: 'Chauffeurs',
          icon: faUsersLine,
          route: '/Transport/Chauffeurs',
          role: ['admin', 'user-facture', 'user', 'super-admin'],
          permission: 'Chauffeurs',
        },
        {
          name: 'Véhicules',
          icon: faTruckRampBox,
          route: '/Transport/Vehicules',
          role: ['admin', 'user-facture', 'user', 'super-admin'],
          permission: 'Vehicules',
        },
      ],
    },
    {
      name: 'Clients',
      icon: faPeopleRoof,
      route: 'null',
      role: ['admin', 'user-facture', 'user', 'super-admin'],
      child: [
        {
          name: 'Client List',
          icon: faUsersLine,
          route: '/Clients/ListClients',
          role: ['admin', 'user-facture', 'user', 'super-admin'],
          permission: 'Clients',
        },
      ],
    },
    {
      name: 'Logistique',
      icon: faWarehouse,
      route: 'null',
      role: ['admin', 'user-facture', 'user', 'super-admin'],
      child: [
        {
          name: 'Stock des scellée',
          icon: faBoxesStacked,
          route: '/Logistique/Stock-scellés',
          role: ['admin', 'user-facture', 'user', 'super-admin'],
          permission: 'Logistique',
        },
      ],
    },
    {
      name: 'Documents',
      icon: faFileText,
      route: 'null',
      role: ['admin', 'user-facture', 'user', 'super-admin'],
      child: [
        {
          name: 'Gestion des Documents',
          icon: faFolderOpen,
          route: '/Documents/Management',
          role: ['admin', 'user-facture', 'user', 'super-admin'],
          permission: 'Documents',
        },
        {
          name: 'Alertes & Rappels',
          icon: faBell,
          route: '/Documents/Alerts',
          role: ['admin', 'user-facture', 'user', 'super-admin'],
          permission: 'Documents',
        },
        {
          name: 'Statistiques',
          icon: faChartBar,
          route: '/Documents/Statistics',
          role: ['admin', 'user-facture', 'user', 'super-admin'],
          permission: 'Documents',
        },
      ],
    },
    {
      name: 'Carburant',
      icon: faGasPump,
      route: '/Carburants',
      role: ['admin', 'user-facture', 'user', 'super-admin'],
      permission: 'Carburants',
    },
    {
      name: 'Factures',
      icon: faFileInvoiceDollar,
      route: '/factures',
      role: ['admin', 'user-facture', 'super-admin'],
    },
    {
      name: 'Gestion des utilisateurs',
      icon: faUser,
      route: '/Gestion-des-utilisateurs',
      role: ['admin', 'super-admin'],
    },
  ];

  useEffect(() => {
    if (isMobile) setSidebarOpen(false);

    const storedAuthState = sessionStorage.getItem('authLocalstorage');
    const parsedAuthState = JSON.parse(storedAuthState || 'null');
    if (!parsedAuthState) {
      navigate('/');
    } else {
      

      if (parsedAuthState.user.role.id === 1) {
        setInfoUser({
          name: parsedAuthState.user.name,
          roles: ['admin'],
          numberRole: parsedAuthState.user.role.id,
          Permissions: parsedAuthState.permissions,
        });
        
      }
      if (parsedAuthState.user.role.id === 2) {
        setInfoUser({
          name: parsedAuthState.user.name,
          roles: ['user'],
          numberRole: parsedAuthState.user.role.id,
          Permissions: parsedAuthState.permissions,
        });
      }
      
      if (parsedAuthState.user.role.id === 3) {
        setInfoUser({
          name: parsedAuthState.user.name,
          roles: ['super-admin'],
          numberRole: parsedAuthState.user.role.id,
          Permissions: parsedAuthState.permissions,
        });
      }
      
      if (parsedAuthState.user.role.id === 4) {
        setInfoUser({
          name: parsedAuthState.user.name,
          roles: ['user-facture'],
          numberRole: parsedAuthState.user.role.id,
          Permissions: parsedAuthState.permissions,
        });
      }
    }
  }, [isMobile, navigate]);

  // Communiquer l'état de la sidebar au composant parent
 useEffect(() => {
    if (knowSidebarOpen) {
      knowSidebarOpen(sidebarOpen);
    }
  }, [sidebarOpen, knowSidebarOpen]);

  const handleMenuClick = (route) => {
    navigate(route);
    setActiveDropdown(null);
  };

  const handleLayoutToggle = () => {
    const newValue = !isNavbar;
    setIsNavbar(newValue);
    knowIsNavbar(newValue);
    console.log(knowIsNavbar , isNavbar);
    localStorage.setItem('layoutPreference', JSON.stringify(newValue));
    if (!newValue) setSidebarOpen(false);
  };

  const handleMobileMenuToggle = () => setMobileMenuOpen((p) => !p);

  const handleLogoClick = () => {
    if (isNavbar) handleLayoutToggle();
    else setSidebarOpen((prev) => !prev);
  };

  
   const canListPermission = React.useCallback((permName) => {
  if (!permName) return true;
  const perm = infoUser.Permissions?.find(
    (p) => p.name?.toLowerCase() === permName.toLowerCase()
  );
  return perm?.actions?.some((a) => Number(a.allowed) > 0) || false;
}, [infoUser.Permissions]);


const filteredSidebarInfo = React.useMemo(() => {
  if (!infoUser?.roles?.length) return SidebarInfo;

  return SidebarInfo.map((item) => ({
    ...item,
    child: item.child
      ? item.child.filter(
          (child) =>
            child.role.some((r) => infoUser.roles.includes(r)) &&
            (!child.permission || canListPermission(child.permission))
        )
      : undefined,
  }))
    .filter((item) => {
      const hasRole = item.role.some((r) => infoUser.roles.includes(r));
      const canList = !item.permission || canListPermission(item.permission);
      const hasChildren = !item.child || item.child.length > 0;
      return hasRole && canList && hasChildren;
    });
}, [infoUser.roles, infoUser.Permissions]);

  const MobileMenu = () => (
    <Box
      sx={{
        position: 'fixed',
        boxShadow: '20px 20px 42px rgba(0,0,0,0.1)',
        transition: 'transform 0.3s ease, width 0.3s ease',
        top: '60px',
        width: '60%',
        left: 0,
        right: 0,
        bottom: 0,
        bgcolor: 'background.body',
        zIndex: 1250,
        overflowY: 'auto',
        p: 2,
        display: mobileMenuOpen ? 'block' : 'none',
      }}
    >
      {filteredSidebarInfo.length > 0 && filteredSidebarInfo.map((item) => (
        <Box key={item.name} sx={{ mb: 2 }}>
          <Typography
            level="body-md"
            onClick={() => {
              if (!item.child) {
                handleMenuClick(item.route);
                setMobileMenuOpen(false);
              }
            }}
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1,
              mb: 1,
              fontWeight: 'bold',
              cursor: 'pointer',
              padding: '10px 20px',
              borderRadius: '18px',
              backgroundColor: 'rgb(11, 14, 57)',
              color: 'white',
            }}
          >
            <FontAwesomeIcon icon={item.icon} />
            {item.name}
          </Typography>
          {item.child && (
            <Box sx={{ pl: 3 }}>
              {item.child.map((child) => (
                <Box
                  key={child.name}
                  onClick={() => {
                    handleMenuClick(child.route);
                    setMobileMenuOpen(false);
                  }}
                  sx={{
                    py: 1,
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                    cursor: 'pointer',
                    '&:hover': { color: 'primary.main' },
                  }}
                >
                  <FontAwesomeIcon icon={child.icon} />
                  <Typography level="body-sm">{child.name}</Typography>
                </Box>
              ))}
            </Box>
          )}
        </Box>
      ))}
    </Box>
  );

  // Prevent rendering before user info is ready
  if (!infoUser.name) return null;


  return (
    <CssVarsProvider>
      <>
        <MobileMenuButton
          isNavbar={isNavbar}
          sidebarOpen={sidebarOpen}
          toggleSidebar={toggleSidebar}
        />

        {isNavbar ? (
          <>
            <NavbarContainer sx={{  backgroundColor: 'rgb(11, 14, 57)' }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 5, width: '100%', height: '100%' }}>
                <img
                  src={sidebarLogo}
                  alt="Logo"
                  style={{ height: isMobile ? '30px' : '40px', cursor: 'pointer' }}
                  onClick={handleLogoClick}
                />

                {isMobile ? (
                  <>
                    <Box sx={{ flexGrow: 1 }} />
                    <IconButton onClick={handleMobileMenuToggle} variant="soft" color="neutral">
                      <FontAwesomeIcon icon={faBars} />
                    </IconButton>
                  </>
                ) : (
                  <>
                    <Box sx={{ display: 'flex', gap: 2, flexGrow: 1 }}>
                      {filteredSidebarInfo.length > 0 && filteredSidebarInfo.map((item) => (
                        <Dropdown key={item.name}>
                          <MenuButton
                            sx={{
                              color: 'neutral.700',
                              '&:hover': { color: 'primary.main', bgcolor: 'rgba(25, 118, 210, 0.08)' },
                              borderRadius: 'md',
                              p: '8px 12px',
                              transition: 'all 0.2s ease',
                            }}
                          >
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, '& svg': { fontSize: '1rem' } }}>
                              <FontAwesomeIcon color="white" icon={item.icon} />
                              <Typography sx={{ color: 'white' }} level="body-sm">
                                {item.name}
                              </Typography>
                            </Box>
                          </MenuButton>
                          <Menu
                            sx={{
                              minWidth: 180,
                              bgcolor: 'background.body',
                              borderRadius: 'lg',
                              boxShadow: 'md',
                              p: 1,
                              zIndex: 1400,
                              position: 'relative',
                            }}
                          >
                            {(item.child ?? [item]).map((child) => (
                              <MenuItem key={child.name} onClick={() => handleMenuClick(child.route)}>
                                <ListItemDecorator>
                                  <FontAwesomeIcon icon={child.icon} />
                                </ListItemDecorator>
                                {child.name}
                              </MenuItem>
                            ))}
                          </Menu>
                        </Dropdown>
                      ))}
                    </Box>

                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <FontAwesomeIcon icon={faRepeat} />
                        <Switch checked={isNavbar} onChange={handleLayoutToggle} size="sm" />
                      </Box>

                      <Dropdown>
                        <UserProfileButton
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 1,
                            backgroundColor: 'white',
                            color: '#151B54',
                            p: '8px',
                            borderRadius: '50px',
                            transition: 'background-color 0.3s, color 0.3s',
                            '&:hover': { backgroundColor: '#151B54', color: 'whitesmoke' },
                          }}
                        >
                          <Avatar size="sm" />
                          <Typography level="body-sm" color="white" fontWeight="bold">
                            {infoUser.name}
                          </Typography>
                          <FontAwesomeIcon icon={faChevronDown} size="xs" />
                        </UserProfileButton>

                        <Menu
                          placement="bottom-end"
                          sx={{
                            minWidth: 220,
                            bgcolor: '#ffffff',
                            borderRadius: '16px',
                            boxShadow: '0 20px 60px rgba(0, 0, 0, 0.15), 0 8px 25px rgba(0, 0, 0, 0.1)',
                            p: 0,
                            mt: 0.5,
                            ml: -1,
                            zIndex: 9999,
                            border: '1px solid rgba(0, 0, 0, 0.08)',
                            backdropFilter: 'blur(10px)',
                            overflow: 'hidden',
                          }}
                        >
                          {/* Header du dropdown */}
                          <Box sx={{ 
                            p: 2, 
                            borderBottom: '1px solid rgba(0, 0, 0, 0.06)',
                            bgcolor: 'rgba(0, 0, 0, 0.02)',
                            display: 'flex',
                            alignItems: 'center',
                            gap: 1
                          }}>
                            <Avatar size="sm" />
                            <Typography sx={{ 
                              fontSize: '14px', 
                              fontWeight: '600', 
                              color: '#1f2937'
                            }}>
                              {infoUser.name}
                            </Typography>
                          </Box>

                          <MenuItem 
                            onClick={() => {
                              navigate('/Profile');
                              setAccountMenuOpen(false);
                            }}
                            sx={{
                              minHeight: 48,
                              borderRadius: '0',
                              color: '#374151',
                              px: 2,
                              py: 1.5,
                              '&:hover': {
                                bgcolor: 'rgba(59, 130, 246, 0.05)',
                                color: '#1d4ed8'
                              },
                              transition: 'all 0.2s ease'
                            }}
                          >
                            <Box sx={{ 
                              width: 24, 
                              height: 24,
                              display: 'flex', 
                              justifyContent: 'center', 
                              alignItems: 'center',
                              mr: 2,
                              borderRadius: '6px',
                              bgcolor: 'rgba(107, 114, 128, 0.1)',
                              color: '#6b7280'
                            }}>
                              <FontAwesomeIcon icon={faUser} style={{ fontSize: 12 }}  />
                            </Box>
                            <Typography level="body-sm" sx={{ fontWeight: '500', color: 'inherit' }}>
                              Profile
                            </Typography>
                          </MenuItem>

                          {/* <MenuItem 
                            onClick={() => setAccountMenuOpen(false)}
                            sx={{
                              minHeight: 48,
                              borderRadius: '0',
                              color: '#374151',
                              px: 2,
                              py: 1.5,
                              '&:hover': {
                                bgcolor: 'rgba(59, 130, 246, 0.05)',
                                color: '#1d4ed8'
                              },
                              transition: 'all 0.2s ease'
                            }}
                          >
                            <Box sx={{ 
                              width: 24, 
                              height: 24,
                              display: 'flex', 
                              justifyContent: 'center', 
                              alignItems: 'center',
                              mr: 2,
                              borderRadius: '6px',
                              bgcolor: 'rgba(107, 114, 128, 0.1)',
                              color: '#6b7280'
                            }}>
                              <FontAwesomeIcon icon={faGear} style={{ fontSize: 12 }} />
                            </Box>
                            <Typography level="body-sm" sx={{ fontWeight: '500', color: 'inherit' }}>
                              Settings
                            </Typography>
                          </MenuItem> */}

                          <Box sx={{ height: 1, bgcolor: 'rgba(0, 0, 0, 0.06)', mx: 2 }} />

                          <MenuItem 
                            onClick={() => {
                              handleLogout();
                              setAccountMenuOpen(false);
                            }}
                            sx={{
                              minHeight: 48,
                              borderRadius: '0',
                              color: '#dc2626',
                              px: 2,
                              py: 1.5,
                              '&:hover': {
                                bgcolor: 'rgba(239, 68, 68, 0.05)',
                                color: '#b91c1c'
                              },
                              transition: 'all 0.2s ease'
                            }}
                          >
                            <Box sx={{ 
                              width: 24, 
                              height: 24,
                              display: 'flex', 
                              justifyContent: 'center', 
                              alignItems: 'center',
                              mr: 2,
                              borderRadius: '6px',
                              bgcolor: 'rgba(239, 68, 68, 0.1)',
                              color: '#dc2626'
                            }}>
                              <FontAwesomeIcon icon={faRightFromBracket} style={{ fontSize: 12 }} />
                            </Box>
                            <Typography level="body-sm" sx={{ fontWeight: '500', color: 'inherit' }}>
                              Logout
                            </Typography>
                          </MenuItem>

                          {/* Footer avec padding */}
                          <Box sx={{ height: 8 }} />
                        </Menu>
                      </Dropdown>
                    </Box>
                  </>
                )}
              </Box>
            </NavbarContainer>
            {isMobile && <MobileMenu />}
          </>
        ) : (
          <>
            {/* Mobile Overlay */}
            {isMobile && sidebarOpen && (
              <Box
                sx={{
                  position: 'fixed',
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  bgcolor: 'rgba(0, 0, 0, 0.6)',
                  zIndex: 1199,
                  backdropFilter: 'blur(2px)',
                }}
                onClick={toggleSidebar}
              />
            )}
            <Box
              sx={{
                position: 'fixed',
                left: 0,
                top: 0,
                bottom: 0,
                width: sidebarOpen ? '280px' : '80px',
                minWidth: sidebarOpen ? '280px' : '80px',
                maxWidth: sidebarOpen ? '280px' : '80px',
                height: 'auto',
                transition: 'width 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                bgcolor: '#0B0E39', // Bleu très foncé comme dans l'image
                borderRight: '1px solid #1a1d4e',
                boxShadow: { xs: '0 8px 32px rgba(0, 0, 0, 0.3)', md: '0 4px 12px rgba(0, 0, 0, 0.1)' },
                display: 'flex',
                flexDirection: 'column',
                zIndex: 1200,
                overflow: 'hidden',
                transform: { xs: sidebarOpen ? 'translateX(0)' : 'translateX(-100%)', md: 'none' },
                flexShrink: 0,
              }}
            >
            <Box
              sx={{
                p:3,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                borderBottom: '1px solid #1a1d4e',
                minHeight: '72px',
                backgroundColor: '#0B0E39',
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <img
                  onClick={handleLogoClick}
                  src={sidebarOpen ? sidebarLogo : smallLogo}
                  alt="Logo"
                  style={{ 
                    height: sidebarOpen ? '40px' : '32px', 
                    transition: 'all 0.3s ease', 
                    cursor: 'pointer',
                    borderRadius: '6px'
                  }}
                />
                {/* {sidebarOpen && (
                  <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', ml: 0.5 }}>
                    <Typography 
                      sx={{ 
                        color: 'white', 
                        fontSize: '16px', 
                        fontWeight: '700',
                        lineHeight: 1,
                        letterSpacing: '0.3px',
                        fontFamily: 'system-ui, -apple-system, sans-serif'
                      }}
                    >
                      EBN
                    </Typography>
                    <Typography 
                      sx={{ 
                        color: '#a1a9b8', 
                        fontSize: '10px', 
                        fontWeight: '600',
                        lineHeight: 1,
                        letterSpacing: '0.8px',
                        fontFamily: 'system-ui, -apple-system, sans-serif'
                      }}
                    >
                      LOGISTICS
                    </Typography>
                  </Box>
                )} */}
              </Box>
             
            </Box>

            <Box sx={{ display: 'flex',  justifyContent: 'center', flexDirection: 'column', height: 'calc(100% - 72px)', position: 'relative' }}>
              <List
                sx={{
                  px: 1.5,
                  py: 2,
                  overflowY: 'auto',
                  '&::-webkit-scrollbar': { width: '3px' },
                  '&::-webkit-scrollbar-track': { background: 'transparent' },
                  '&::-webkit-scrollbar-thumb': { background: '#1a1d4e', borderRadius: '3px' },
                  '&::-webkit-scrollbar-thumb:hover': { background: '#2a2d5e' },
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 0.25,
                  flexGrow: 0,
                }}
              >
                {filteredSidebarInfo.length > 0 && filteredSidebarInfo.map((item) => (
                  <React.Fragment key={item.name}>
                    {!sidebarOpen && item.child ? (
                      <Dropdown 
                        open={activeDropdown === item.name} 
                        onOpenChange={() => {
                          // Ne pas fermer automatiquement du tout
                          console.log('Dropdown onOpenChange called but ignored');
                        }}
                      >
                        <MenuButton
                          slots={{ root: ListItemButton }}
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            console.log('Clicking dropdown for:', item.name);
                            console.log('Current activeDropdown:', activeDropdown);
                            setActiveDropdown(activeDropdown === item.name ? null : item.name);
                          }}
                          sx={{
                            minHeight: 48,
                            borderRadius: '8px',
                            justifyContent: 'center',
                            px: 1.5,
                            color: '#a1a9b8',
                            '&:hover': { 
                              bgcolor: '#1a1d4e', 
                              color: '#ffffff' 
                            },
                            mb: 0.25,
                            transition: 'all 0.2s ease',
                            width: '100%',
                          }}
                        >
                          <Box sx={{ width: 24, display: 'flex', justifyContent: 'center', color: 'inherit' }}>
                            <FontAwesomeIcon icon={item.icon} />
                          </Box>
                        </MenuButton>
                        <Menu
                          placement="right-start"
                          className="dropdown-menu"
                          sx={{
                            minWidth: 200,
                            bgcolor: '#ffffff',
                            borderRadius: '12px',
                            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.12)',
                            p: 1,
                            zIndex: 9999,
                            border: '1px solid #e5e7eb',
                            '--ListItem-radius': '8px',
                          }}
                        >
                          {/* Bouton de fermeture */}
                          <MenuItem 
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              console.log('Closing dropdown manually');
                              setActiveDropdown(null);
                            }}
                            sx={{ 
                              justifyContent: 'center',
                              color: '#6b7280',
                              fontSize: '12px',
                              minHeight: 32,
                              borderBottom: '1px solid #e5e7eb',
                              '&:hover': {
                                bgcolor: '#f3f4f6',
                                color: '#374151'
                              }
                            }}
                          >
                            ✕ Fermer
                          </MenuItem>
                          {item.child.map((child) => (
                            <MenuItem 
                              key={child.name} 
                              onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                handleMenuClick(child.route);
                                setActiveDropdown(null);
                              }} 
                              sx={{ 
                                minHeight: 44, 
                                borderRadius: '8px',
                                color: '#374151',
                                '&:hover': {
                                  bgcolor: '#f3f4f6',
                                  color: '#111827'
                                },
                                transition: 'all 0.2s ease',
                                px: 1.5,
                                py: 1
                              }}
                            >
                              <Box sx={{ width: 20, display: 'flex', justifyContent: 'center', mr: 1.5 }}>
                                <FontAwesomeIcon icon={child.icon} style={{ fontSize: 13, color: '#6b7280' }} />
                              </Box>
                              <Typography level="body-sm" sx={{ fontWeight: '500', color: 'inherit' }}>
                                {child.name}
                              </Typography>
                            </MenuItem>
                          ))}
                        </Menu>
                      </Dropdown>
                    ) : (
                      <ListItem sx={{ my: 0.25 }}>
                        <ListItemButton
                          onClick={() => {
                            if (item.route !== 'null') handleMenuClick(item.route);
                            else setActiveDropdown(activeDropdown === item.name ? null : item.name);
                          }}
                          selected={activeDropdown === item.name}
                          sx={{
                            minHeight: 40,
                            borderRadius: '8px',
                            bgcolor: activeDropdown === item.name ? '#1a1d4e' : 'transparent',
                            color: '#a1a9b8',
                            justifyContent: 'center',
                            position: 'relative',
                            '&:hover': { 
                              bgcolor: '#1a1d4e', 
                              color: '#ffffff' 
                            },
                            mb: 0.25,
                            px: 1.5,
                            transition: 'all 0.2s ease',
                            width: '100%',
                            // Indicateur pour l'élément actif
                            ...(location.pathname === item.route && {
                              bgcolor: '#1a1d4e',
                              color: '#ffffff',
                              '&::before': {
                                content: '""',
                                position: 'absolute',
                                left: 0,
                                top: '50%',
                                transform: 'translateY(-50%)',
                                width: '3px',
                                height: '20px',
                                backgroundColor: '#ffffff',
                                borderRadius: '0 2px 2px 0',
                              }
                            }),
                          }}
                        >
                          <Box sx={{ width: 20, display: 'flex', textAlign: 'center', justifyContent: 'center', mr: sidebarOpen ? 1 : 0 }}>
                            <FontAwesomeIcon icon={item.icon}   style={{ fontSize: 14   }} />
                          </Box>
                          {sidebarOpen && (
                            <>
                              <ListItemContent>
                                <Typography level="body-sm" sx={{ color: 'inherit', fontWeight: '500', fontSize: '14px' }}>
                                  {item.name}
                                </Typography>
                              </ListItemContent>
                              {item.child && (
                                <FontAwesomeIcon
                                  icon={activeDropdown === item.name ? faChevronUp : faChevronDown}
                                  style={{ fontSize: 10, color: 'inherit' }}
                                />
                              )}
                            </>
                          )}
                        </ListItemButton>
                      </ListItem>
                    )}

                    {sidebarOpen && item.child && activeDropdown === item.name && (
                      <List sx={{ pl: 1.5, pr: 1, mt: 0.5 }}>
                        {item.child.map((child) => (
                          <ListItem key={child.name} sx={{ py: 0.25 }}>
                            <ListItemButton
                              onClick={() => handleMenuClick(child.route)}
                              sx={{
                                minHeight: 40,
                                borderRadius: '6px',
                                color: '#9ca3af',
                                '&:hover': { 
                                  bgcolor: '#1a1d4e', 
                                  color: '#ffffff' 
                                },
                                px: 1.5,
                                transition: 'all 0.2s ease',
                                width: '100%',
                              }}
                            >
                              <Box sx={{ width: 16, display: 'flex', justifyContent: 'center', mr: 1.5 }}>
                                <FontAwesomeIcon icon={child.icon} style={{ fontSize: 11 }} />
                              </Box>
                              <Typography level="body-sm" sx={{ color: 'inherit', fontSize: '13px', fontWeight: '400' }}>
                                {child.name}
                              </Typography>
                            </ListItemButton>
                          </ListItem>
                        ))}
                      </List>
                    )}
                  </React.Fragment>
                ))}
              </List>

              <Box
                sx={{
                  mt: 'auto',
                  borderTop: '1px solid #1a1d4e',
                  p: 1.5,
                  backgroundColor: '#0B0E39',
                  position: 'relative',
                  zIndex: 1300,
                }}
              >
                <ListItem sx={{ mb: 0.75 }}>
                  <ListItemButton
                    onClick={toggleAccountMenu}
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: 1.5,
                      backgroundColor: '#1a1d4e',
                      color: '#a1a9b8',
                      p: '10px',
                      borderRadius: '8px',
                      transition: 'all 0.2s ease',
                      '&:hover': { 
                        backgroundColor: '#2a2d5e', 
                        color: '#ffffff' 
                      },
                    }}
                  >
                    <Avatar size="sm" />
                    <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
                     {sidebarOpen && <Typography level="body-sm" color="inherit" fontWeight="500" fontSize="13px">
                        {infoUser.name}
                      </Typography>}
                    </Box>

                    <Dropdown open={accountMenuOpen} onOpenChange={setAccountMenuOpen}>
                      <MenuButton variant="plain" size="sm" sx={{ minWidth: 'unset', p: 1 }}>
                        <FontAwesomeIcon icon={faChevronDown} size="xs" />
                      </MenuButton>
                      <Menu
                        placement="top-end"
                        sx={{ 
                          minWidth: 220, 
                          bgcolor: '#ffffff', 
                          borderRadius: '16px', 
                          boxShadow: '0 20px 60px rgba(0, 0, 0, 0.15), 0 8px 25px rgba(0, 0, 0, 0.1)', 
                          p: 0, 
                          zIndex: 9999,
                          border: '1px solid rgba(0, 0, 0, 0.08)',
                          backdropFilter: 'blur(10px)',
                          overflow: 'hidden',
                          mt: -0.5,
                          mr: -1,
                        }}
                      >
                        {/* Header du dropdown */}
                        <Box sx={{ 
                          p: 2, 
                          borderBottom: '1px solid rgba(0, 0, 0, 0.06)',
                          bgcolor: 'rgba(0, 0, 0, 0.02)',
                          display: 'flex',
                          alignItems: 'center',
                          gap: 1
                        }}>
                          <Avatar size="sm" />
                          <Typography sx={{ 
                            fontSize: '14px', 
                            fontWeight: '600', 
                            color: '#1f2937'
                          }}>
                            {infoUser.name}
                          </Typography>
                        </Box>

                        <MenuItem
                          onClick={() => {
                            navigate('/Profile');
                            setAccountMenuOpen(false);
                          }}
                          sx={{
                            minHeight: 48,
                            borderRadius: '0',
                            color: '#374151',
                            px: 2,
                            py: 1.5,
                            '&:hover': {
                              bgcolor: 'rgba(59, 130, 246, 0.05)',
                              color: '#1d4ed8'
                            },
                            transition: 'all 0.2s ease'
                          }}
                        >
                          <Box sx={{ 
                            width: 24, 
                            height: 24,
                            display: 'flex', 
                            justifyContent: 'center', 
                            alignItems: 'center',
                            mr: 2,
                            borderRadius: '6px',
                            bgcolor: 'rgba(107, 114, 128, 0.1)',
                            color: '#6b7280'
                          }}>
                            <FontAwesomeIcon icon={faUser} style={{ fontSize: 12 }} />
                          </Box>
                          <Typography level="body-sm" sx={{ fontWeight: '500', color: 'inherit' }}>
                            Profile
                          </Typography>
                        </MenuItem>

                        {/* <MenuItem 
                          onClick={() => setAccountMenuOpen(false)}
                          sx={{
                            minHeight: 48,
                            borderRadius: '0',
                            color: '#374151',
                            px: 2,
                            py: 1.5,
                            '&:hover': {
                              bgcolor: 'rgba(59, 130, 246, 0.05)',
                              color: '#1d4ed8'
                            },
                            transition: 'all 0.2s ease'
                          }}
                        >
                          <Box sx={{ 
                            width: 24, 
                            height: 24,
                            display: 'flex', 
                            justifyContent: 'center', 
                            alignItems: 'center',
                            mr: 2,
                            borderRadius: '6px',
                            bgcolor: 'rgba(107, 114, 128, 0.1)',
                            color: '#6b7280'
                          }}>
                            <FontAwesomeIcon icon={faGear} style={{ fontSize: 12 }} />
                          </Box>
                          <Typography level="body-sm" sx={{ fontWeight: '500', color: 'inherit' }}>
                            Settings
                          </Typography>
                        </MenuItem> */}

                        <Box sx={{ height: 1, bgcolor: 'rgba(0, 0, 0, 0.06)', mx: 2 }} />

                        <MenuItem
                          onClick={() => {
                            handleLogout();
                            setAccountMenuOpen(false);
                          }}
                          sx={{
                            minHeight: 48,
                            borderRadius: '0',
                            color: '#dc2626',
                            px: 2,
                            py: 1.5,
                            '&:hover': {
                              bgcolor: 'rgba(239, 68, 68, 0.05)',
                              color: '#b91c1c'
                            },
                            transition: 'all 0.2s ease'
                          }}
                        >
                          <Box sx={{ 
                            width: 24, 
                            height: 24,
                            display: 'flex', 
                            justifyContent: 'center', 
                            alignItems: 'center',
                            mr: 2,
                            borderRadius: '6px',
                            bgcolor: 'rgba(239, 68, 68, 0.1)',
                            color: '#dc2626'
                          }}>
                            <FontAwesomeIcon icon={faRightFromBracket} style={{ fontSize: 12 }} />
                          </Box>
                          <Typography level="body-sm" sx={{ fontWeight: '500', color: 'inherit' }}>
                            Logout
                          </Typography>
                        </MenuItem>

                        {/* Footer avec padding */}
                        <Box sx={{ height: 8 }} />
                      </Menu>
                    </Dropdown>
                  </ListItemButton>
                </ListItem>

                <ListItem sx={{ mb: 0.75 }}>
                  <ListItemButton
                    sx={{
                      minHeight: 48,
                      borderRadius: '8px',
                      color: '#a1a9b8',
                      '&:hover': { 
                        bgcolor: '#1a1d4e', 
                        color: '#ffffff' 
                      },
                      display: 'flex',
                      justifyContent: sidebarOpen ? 'space-between' : 'center',
                      alignItems: 'center',
                      px: 1.5,
                      transition: 'all 0.2s ease',
                    }}
                  >
                    <Box
                      sx={{
                        width: 24,
                        display: sidebarOpen ? 'flex' : 'none',
                        justifyContent: 'center',
                        mr: sidebarOpen ? 2 : 0,
                      }}
                    >
                      <FontAwesomeIcon style={{ display: sidebarOpen ? 'block' : 'none' }} icon={faRepeat} />
                    </Box>

                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: sidebarOpen ? 'space-between' : 'center', flex: 1 }}>
                      <Switch checked={isNavbar} onChange={handleLayoutToggle} size="sm" />
                    </Box>
                  </ListItemButton>
                </ListItem>

                {['Support'].map((item) => (
                  <ListItem key={item} sx={{ mb: 0.75 }}>
                    <ListItemButton
                      sx={{
                        minHeight: 48,
                        borderRadius: '8px',
                        color: '#a1a9b8',
                        '&:hover': { 
                          bgcolor: '#1a1d4e', 
                          color: '#ffffff' 
                        },
                        transition: 'all 0.2s ease',
                        display: 'flex',
                        justifyContent: sidebarOpen ? 'flex-start' : 'center',
                        px: 1.5,
                      }}
                    >
                      <Box sx={{ width: 20, display: 'flex', justifyContent: 'center', mr: sidebarOpen ? 1.5 : 0 }}>
                        <FontAwesomeIcon icon={item === 'Support' ? faQuestionCircle : faCogs} style={{ fontSize: 13 }} />
                      </Box>
                      {sidebarOpen && <Typography level="body-sm" color="inherit" fontSize="13px" fontWeight="500">{item}</Typography>}
                    </ListItemButton>
                  </ListItem>
                ))}
              </Box>
            </Box>
          </Box>
          </>
        )}
      </>
    </CssVarsProvider>
  );
}
